/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { DeploymentsSearchResponse, SearchRequest } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState, ProfileState, UserSubscription } from '@modules/ui-types'
import Feature from '@modules/utils/feature'

import { getStackDeploymentsFromSearch } from '@/reducers/stackDeploymentSearches'
import { getDeletedStackDeploymentIds } from '@/reducers/stackDeployments'
import { getExternalSubscription, getProfile } from '@/apps/userconsole/reducers/profile'
import { searchStackDeploymentsRequest } from '@/reducers/asyncRequests/registry'

import { isFeatureActivated } from '../../selectors'
import { searchDeployments } from '../../actions/stackDeployments'

import StackDeploymentSearch from './StackDeploymentSearch'

import type { ReduxState } from '@/types/redux'

type StateProps = {
  deletedDeploymentIds: string[]
  searchResults: DeploymentsSearchResponse | null
  searchResultsRequest: AsyncRequestState
  profile: ProfileState
  subscription?: UserSubscription
  hideCreateClusterButton: boolean
  exportDeployments: boolean
  showIlmMigrationCallout: boolean
}

type DispatchProps = {
  searchDeployments: (query: SearchRequest) => void
}

const mapStateToProps = (state: ReduxState): StateProps => ({
  deletedDeploymentIds: getDeletedStackDeploymentIds(state),
  searchResults: getStackDeploymentsFromSearch(state, `deployments`),
  searchResultsRequest: searchStackDeploymentsRequest(state, `deployments`),
  hideCreateClusterButton: isFeatureActivated(state, Feature.hideCreateClusterButton),
  exportDeployments: isFeatureActivated(state, Feature.exportDeployments),
  profile: getProfile(state),
  subscription: getExternalSubscription(state),
  showIlmMigrationCallout: isFeatureActivated(state, Feature.ilmTemplateMigrationFeature),
})

const mapDispatchToProps: DispatchProps = {
  searchDeployments: (query) => searchDeployments({ queryId: `deployments`, query }),
}

export default connect<StateProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(StackDeploymentSearch)
